import React from 'react'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, SELF_SCHEDULING_DEFAULTS } from '../../moduleRegistry'

interface SelfScheduleModalFooterProps {
  isSubmitting: boolean
  disabled: boolean
  onConfirm: () => void
}

const SelfScheduleModalFooter = ({ isSubmitting, disabled, onConfirm }: SelfScheduleModalFooterProps) => {
  const { scheduleButtonModalCTA } = useModuleConfig(MODULE_KEYS.selfScheduling, SELF_SCHEDULING_DEFAULTS)
  return <div className="self_schedule_modal_footer">
        <button
            className="self_schedule_modal_confirm_button"
            onClick={onConfirm}
            disabled={disabled || isSubmitting}
        >
            {scheduleButtonModalCTA}
        </button>
    </div>
}

export default SelfScheduleModalFooter
